import React from 'react';
import {observer} from 'mobx-react';
import {FilterLinkListComponent} from '../filter-link-list/filter-link-list.component';
import {FiltersGamesMobilePopupBox} from "./boxes/popup/filters-games-mobile-popup.box";
import {FiltersMobileButtonsBox} from "./boxes/popup/menu/filters-mobile-buttons.box";
import {IModalDialogHandler} from "../../../services/dialog/dialog.service.interface";
import { ModalDialogActionsComponent } from '../../modal-dialog/modal-dialog-actions.component';
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {
    IArenaGameFilterEditorViewModel
} from "../../../services/games-filter/arena-filters/arena-game-filter-editor-view-model.interface";
import {
    ISimpleStrategyFiltersEditorViewModel
} from "../../../services/games-filter/strategies/simple-games-filter/simple-strategy-filters-editor-view-model.interface";


export interface FiltersGamesListMobileComponentProps {
    dialogHandler: IModalDialogHandler;
    filtersEditor: ISimpleStrategyFiltersEditorViewModel;
}

@observer
export class FiltersGamesListMobileComponent extends OrbitComponent<FiltersGamesListMobileComponentProps> {


    private _closePopup = () => {
        this.props.dialogHandler.close();
    };

    private _applyFilters = async () => {
        await this.props.filtersEditor.applyFilters();
        const checkedFiltersIds = this.props.filtersEditor.visibleFilters.filter(f => f.on).map(f => f.id);
        this.services.analytics.sendAnalytics("Navigation", this.services.routing.currentRoute.data.arenaType, checkedFiltersIds.join(','));

        this._closePopup();
    };

    private _clearFilters = async () => {
        this.props.filtersEditor.visibleFilters.forEach(f => {
            f.on = false;
        });

        await this._applyFilters();

    };

    private _renderPopupButtons() {
        return (<FiltersMobileButtonsBox className={'cy-filters-games-buttons'}>
            <ModalDialogActionsComponent primaryAction={{
                className: 'cy-apply-filters-button',
                text: this.services.translation.translate('APPLY'),
                onClick: this._applyFilters
            }} secondaryAction={{
                className: 'cy-clear-filters-button',
                text: this.services.translation.translate('CLEAR_ALL'),
                onClick: this._clearFilters
            }} buttonsOnSeparateLines={this.services.mediaQuery.lAndBelow} />
        </FiltersMobileButtonsBox>);
    }

    private _onToggleFilter = (filter: IArenaGameFilterEditorViewModel) => {
        filter.toggleFilter();
    }

    render() {

        if (this.props.filtersEditor.visibleFilters.length === 0) {
            return null;
        }

        return (
            <FiltersGamesMobilePopupBox className={'cy-filters-games-mobile'}>
                <FilterLinkListComponent filters={this.props.filtersEditor.visibleFilters} onToggle={this._onToggleFilter}/>
                {this._renderPopupButtons()}
            </FiltersGamesMobilePopupBox>
        )
    }
}

